module.exports = __webpack_public_path__ + "img/icon-star.778ddc1e.svg";